module.exports = __webpack_public_path__ + "img/yaoqingma.298107a3.png";